export const barcodeCharacterLimit = 12;
export const sampleBarcodeCharacterLimit = 250;
